import { format, FormatOptions } from '~/components/Util/number';

export type LupProps = {
  value: number;
  className?: string;
} & FormatOptions;

export const Lup = ({ value, className, ...formatOptions }: LupProps) => (
  <span className={className}>
    {format(value, { ...formatOptions })} {Math.abs(value) <= 1 ? 'LUP' : 'LUPs'}
  </span>
);
